$(function(){
    var st = $(window).scrollTop();
    // ADD SCROLLED CLASS IN BODY IF SCROLLED
    var scrolled = function(st){
        if (st > 0) {
            $("body").addClass("scrolled");
        } else {
            $("body").removeClass("scrolled");
        };
    }
    // ADD FIX CLASS IN BODY IF SCROLLED > 100
    var headpos = function(st){
        if (st > 100) {
            $('body').addClass('sc100');
        } else {
            $('body').removeClass('sc100');
        };
    };
    scrolled(st);
    headpos(st);
    $(window).scroll(function() { 
        st = $(window).scrollTop();
	    scrolled(st);
	    headpos(st);
	});
});